module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer"
  }, [_vm._v("\n  Neighborhood Guides is made by "), _c('a', {
    attrs: {
      "href": "http://www.dantasse.com"
    }
  }, [_vm._v("Dan Tasse")]), _vm._v(" and collaborators at the "), _c('a', {
    attrs: {
      "href": "https://www.hcii.cmu.edu/"
    }
  }, [_vm._v("CMU HCII")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.cmuchimps.org/"
    }
  }, [_vm._v("CHIMPS Lab.")]), _vm._v(" We welcome feedback at dantasse@cmu.edu.\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79920e62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = 181
// module chunks = 1